import Banner from "components/Header/Banner";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CSSTransition } from "react-transition-group";

export default () => {

    const { t } = useTranslation("page_not_found");

    return (
        <CSSTransition in={true} appear={true} timeout={200} classNames="zt-page__transition">
            <div className='zt-info'>
                <Container>
                    <Row className="justify-content-md-center">
                        <Col xs md={10} lg={8}>
                            <h4 className='zt-info__header light'>{t('label', 'We are having trouble finding that webpage.')}</h4>
                            <div class="zt-info__article__text">{t('description', 'Please check that the web address is correct.')}</div>
                            <Banner />
                        </Col>
                    </Row>
                </Container>
            </div>
        </CSSTransition>
    );
}